import { axiosDS } from '@pp/axios'
import { RequestParams } from 'Models'
import { urls } from 'Constants/Urls'
import {
	RbidosAccessAgentListModel,
	RbidosAgentCreateModel,
	RbidosPointsModel,
} from 'Pages/registry_business_access_neo'

export const rbidosAgentApi = {
	getAllAgents: async (params?: RequestParams) => {
		const res = await axiosDS().get<RbidosAccessAgentListModel[]>(urls.rbidos_access.base_agent, {
			params,
		})
		return res.data
	},

	getOneAgent: async (id: string) => {
		const res = await axiosDS().get<RbidosAgentCreateModel>(
			`${urls.rbidos_access.base_agent}/${id}`
		)
		return res.data
	},

	createOneAgent: async (data: RbidosAgentCreateModel) => {
		const res = await axiosDS().post<RbidosAgentCreateModel>(urls.rbidos_access.base_agent, {
			data,
		})
		return res.data
	},

	updateOneAgent: async (id: string, data: RbidosAgentCreateModel) => {
		const res = await axiosDS().patch<RbidosAgentCreateModel>(
			`${urls.rbidos_access.base_agent}/${id}`,
			{
				data,
			}
		)
		return res.data
	},
	getIdentificationPoints: async (params?: RequestParams) => {
		const res = await axiosDS().get<RbidosPointsModel[]>(urls.rbidos_access.identification_points, {
			params,
		})
		return res.data
	},
}
